/* eslint-disable */
import a from './o.js'
import r1 from './r1.js'
import o from './rr.js'
import s from './runu.js'

var l = function (e) {
  function r(e, t) {
    var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {
      ratio: .25
    };
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, r);
    var i = function (e, t) {
      if (!e)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t
    }(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e, t, n));
    return i.id = e,
      i.view = t,
      i.options = n,
      i.viewWrapper = document.querySelector("#what"),
      i.tablet = i.view.querySelector(".tablet--item--tablet"),
      i.whale = i.view.querySelector(".tablet--item--whale"),
      i.waterfront = i.view.querySelector(".tablet--item--water-front"),
      i.waterback = i.view.querySelector(".tablet--item--water-back"),
      i.fishfront = i.view.querySelector(".tablet--item--fishes-front"),
      i.fishback = i.view.querySelector(".tablet--item--fishes-back"),
      i.shadow = i.view.querySelector(".tablet--item--shadow"),
      i.whaleImg = i.whale.querySelector("img"),
      i.rotateX = 0,
      i.rotateY = 0,
      i.hover = !0,
      i.mouse = {
        x: 0,
        y: 0
      },
      i.amplitudeX = 9,
      i.amplitudeY = 9,
      i.onMouseEnter = i.onMouseEnter.bind(i),
      i.onMouseMove = i.onMouseMove.bind(i),
      i.onMouseOut = i.onMouseOut.bind(i),
      i.movePerspective = i.movePerspective.bind(i),
      i.whaleImgLoaded = i.whaleImgLoaded.bind(i),
      i.whaleImg.addEventListener("load", i.whaleImgLoaded),
      TweenMax.delayedCall(.5, function () {
        i.initTimelineWhale()
      }),
      i
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(r, a.default),
    r1(r, [{
      key: "whaleImgLoaded",
      value: function () {
        this.viewRect = this.viewWrapper.getBoundingClientRect(),
          this.viewRectHalfW = this.viewRect.width / 2,
          this.viewRectHalfH = this.viewRect.height / 2
      }
    }, {
      key: "initTimelineWhale",
      value: function () {
        this.tlWhale = new TimelineMax({
          paused: !0
        }),
          this.tlWhale.from(this.tablet, 3.5, {
            css: {
              scale: 1.05
            },
            ease: Power3.easeOut
          }),
          this.tlWhale.from([this.whale, this.waterfront, this.waterback], 3.5, {
            css: {
              x: 50,
              scale: .85
            },
            ease: Power3.easeOut
          }, "-=3.5"),
          this.tlWhale.from(this.waterback, .8, {
            css: {
              opacity: 0
            },
            ease: Linear.easeNone
          }, "-=3"),
          this.tlWhale.from(this.waterfront, .8, {
            css: {
              opacity: 0
            },
            ease: Linear.easeNone
          }, "-=2"),
          this.tlWhale.from(this.fishfront, 3.5, {
            css: {
              opacity: 0,
              x: 50,
              y: -10,
              scale: .85
            },
            ease: Power3.easeOut
          }, "-=3"),
          this.tlWhale.from(this.fishback, 3, {
            css: {
              opacity: 0,
              x: 40,
              scale: .8
            },
            ease: Power3.easeOut
          }, "-=2.85")
      }
    }, {
      key: "display",
      value: function () {
        if (!this.tlWhale) return
        o(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "display", this).call(this),
          this.tlWhale.play(),
          s.default.bind(this.id, this.movePerspective),
          this.viewWrapper.addEventListener("mouseover", this.onMouseEnter),
          window.addEventListener("mousemove", this.onMouseMove),
          this.viewWrapper.addEventListener("mouseout", this.onMouseOut)
      }
    }, {
      key: "hide",
      value: function () {
        o(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "hide", this).call(this),
          s.default.unbind(this.id),
          this.viewWrapper.removeEventListener("mouseover", this.onMouseEnter),
          window.removeEventListener("mousemove", this.onMouseMove),
          this.viewWrapper.removeEventListener("mouseout", this.onMouseOut)
      }
    }, {
      key: "onMouseEnter",
      value: function (e) {
        this.hover = !0,
          this.movePerspective()
      }
    }, {
      key: "onMouseMove",
      value: function (e) {
        this.hover ? (this.mouse.x = e.offsetX,
          this.mouse.y = e.offsetY) : (this.mouse.x = this.viewRectHalfW,
            this.mouse.y = this.viewRectHalfH)
      }
    }, {
      key: "onMouseOut",
      value: function () {
        this.hover = !1
      }
    }, {
      key: "movePerspective",
      value: function () {
        var e = this.mouse.x / this.viewRect.width * 2 - 1;
        this.mouse.y,
          this.viewRect.height;
        this.rotateY += .03 * (e * this.amplitudeY - this.rotateY),
          this.view.style.transform = this.view.style.webkitTransform = "rotateY(" + this.rotateY.toFixed(3) + "deg)"
      }
    }, {
      key: "dispose",
      value: function () {
        s.default.unbind(this.id),
          this.whaleImg.removeEventListener("load", this.whaleImgLoaded),
          this.viewWrapper.removeEventListener("mouseover", this.onMouseEnter),
          window.removeEventListener("mousemove", this.onMouseMove),
          this.viewWrapper.removeEventListener("mouseout", this.onMouseOut),
          this.tlWhale && this.tlWhale.kill(),
          this.tlWhale = null,
          this.viewWrapper = null,
          this.tablet = null,
          this.whale = null,
          this.waterfront = null,
          this.waterback = null,
          this.fishfront = null,
          this.fishback = null,
          this.shadow = null,
          this.whaleImg = null,
          this.rotateX = null,
          this.rotateY = null,
          this.hover = null,
          this.mouse = null,
          this.amplitudeX = null,
          this.amplitudeY = null,
          o(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "dispose", this).call(this)
      }
    }]),
    r
}();

export default l
